import { Injectable, inject } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { OfferService } from 'src/app/shared/services/offers/offers.service';
import { RequestService } from 'src/app/shared/services/request.service';

import { OfferOverviewDataSource } from './offer-overview.datasource';
import { RequestsOverviewDataSource } from './requests-overview.datasource';

@Injectable({
  providedIn: 'root',
})
export class DataSourceService {
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);
  private readonly offerService = inject(OfferService);
  private readonly requestService = inject(RequestService);

  public offerDataSource: OfferOverviewDataSource;
  public requestDataSource: RequestsOverviewDataSource;

  constructor() {
    this.offerDataSource = new OfferOverviewDataSource(
      this.store,
      this.actions$,
      this.offerService,
    );

    this.requestDataSource = new RequestsOverviewDataSource(
      this.store,
      this.actions$,
      this.requestService,
    );
  }
}
